import { useMemo } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterRoad, MapAdapterBoundingBox } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_ROADWORK, APP_ROAD } from "../../../../common/constants/appRoad"
import { MODULE_ROADWORKS } from "../../../../common/constants/modules"
import { RoadworkSectionAdapter } from "../../containers/RoadworkSectionAdapter"

import { RoadworkValidator } from "../RoadworkValidator/RoadworkValidator"

export function RoadworksDesktopRoutes() {

    const match = useMatch(`:slugId/${APP_ROAD}/${MODULE_ROADWORKS}/:road/:roadworkUuid`)
    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const roadworksRoutes = useMemo(() => ([
        {
            path: "/",
            element: <>
                <MapAdapterBoundingBox module={API_MODULE_ROADWORK} />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road",
            element: <>
                <MapAdapterRoad module={API_MODULE_ROADWORK} />
                <DetailSegmentSelectListener />
            </>,
        },
        {
            path: "/:road/:roadworkUuid/*",
            element: <RoadworkValidator>
                <RoadworkSectionAdapter roadworkUuid={match?.params?.roadworkUuid} />
                <DetailSegmentSelectListener />
            </RoadworkValidator>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ]), [match, searchParams])

    return useRoutes(roadworksRoutes)
}